import { Component, input, output } from '@angular/core';

import { AppMenuItem } from '../../home.models';

@Component({
  selector: 'app-chat-app-rail',
  imports: [],
  templateUrl: './chat-app-rail.component.html',
  styleUrl: './chat-app-rail.component.scss'
})
export class ChatAppRailComponent {
  readonly items = input.required<AppMenuItem[]>();
  readonly selectedKey = input.required<AppMenuItem['key']>();
  readonly notificationCounts = input<Partial<Record<AppMenuItem['key'], number>>>({});
  readonly appVersion = input<string>('');
  readonly menuSelect = output<AppMenuItem['key']>();

  protected onSelectMenu(key: AppMenuItem['key']): void {
    this.menuSelect.emit(key);
  }

  protected getNotificationCount(key: AppMenuItem['key']): number {
    return this.notificationCounts()[key] ?? 0;
  }

  protected formatNotificationCount(count: number): string {
    return count > 99 ? '99+' : String(count);
  }
}
